import { removeBackground } from '@imgly/background-removal'
import Logger from './logger.js'

document.addEventListener('DOMContentLoaded', function () {
  const fileInput = document.getElementById('file-input')
  const uploadBtn = document.getElementById('upload-btn')
  const processedImg = document.getElementById('processed-img')
  const downloadBtn = document.getElementById('download-btn')
  const imagePreview = document.getElementById('image-preview')
  const dropzone = document.getElementById('dropzone')
  const signatureScannerLink = document.querySelector('a[href*="quick-esign"]')
  const linkedinLink = document.querySelector(
    'a[href*="linkedin.com/in/mamboue"]'
  )

  // Function to reset button state
  function resetButtonState() {
    uploadBtn.disabled = false
    uploadBtn.classList.remove('loading')
    uploadBtn.textContent = 'Upload Image'
  }

  // Function to set button to loading state
  function setButtonLoading() {
    uploadBtn.disabled = true
    uploadBtn.classList.add('loading')
    uploadBtn.textContent = 'Processing...'
  }

  // Dropzone functionality
  if (dropzone) {
    // Click to browse
    dropzone.addEventListener('click', function (e) {
      fileInput.click()
    })

    // Highlight dropzone on dragover
    ;['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(
        eventName,
        function (e) {
          e.preventDefault()
          e.stopPropagation()
          dropzone.classList.add('highlight')
        },
        false
      )
    })

    // Remove highlight on dragleave/drop
    ;['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(
        eventName,
        function (e) {
          e.preventDefault()
          e.stopPropagation()
          dropzone.classList.remove('highlight')
        },
        false
      )
    })

    // Handle drop event
    dropzone.addEventListener(
      'drop',
      function (e) {
        const dt = e.dataTransfer
        const files = dt.files

        if (files.length > 0) {
          fileInput.files = files
          handleFile(files[0])
        }
      },
      false
    )
  }

  // Handle file selection from input
  fileInput.addEventListener('change', function (e) {
    if (e.target.files.length > 0) {
      Logger.debug('image_upload', 'File selected via input')
      handleFile(e.target.files[0])
    }
  })

  // Handle the selected file
  function handleFile(file) {
    // Hide the preview until processing is complete
    imagePreview.style.display = 'none'
    downloadBtn.style.display = 'none'

    // Start processing immediately
    processImage(file)
  }

  // Process the selected image
  async function processImage(file) {
    if (!file) {
      resetButtonState()
      return
    }

    try {
      // Show loading state on button
      setButtonLoading()

      // Process the image
      const blob = await removeBackground(file, {
        // No progress updates to keep it simple
      })

      // Display processed image
      const processedUrl = URL.createObjectURL(blob)
      processedImg.src = processedUrl
      processedImg.style.display = 'block'

      // Show the preview section with the processed image
      imagePreview.style.display = 'flex'

      // Setup download link
      downloadBtn.href = processedUrl
      downloadBtn.download = file.name + '-erased-bg' + '.png'
      downloadBtn.style.display = 'block'

      // Log successful processing
      Logger.debug('processing_success', 'Image processed successfully')

      // Scroll to the processed image on mobile
      // Use setTimeout to ensure the DOM has updated
      setTimeout(() => {
        imagePreview.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
    } catch (error) {
      console.error('Error removing background:', error)
      Logger.notify(
        'processing_error',
        true,
        'Error processing image',
        error.message
      )
      alert('Error processing image: ' + error.message)
    } finally {
      // Restore button state
      resetButtonState()
    }
  }

  // Track signature scanner link clicks
  if (signatureScannerLink) {
    signatureScannerLink.addEventListener('click', function (e) {
      Logger.debug(
        'signature_scanner_click',
        'User clicked signature scanner link'
      )
    })
  }

  // Track download button clicks
  downloadBtn.addEventListener('click', function (e) {
    Logger.debug('image_download', 'Download button clicked')
  })

  // Track LinkedIn profile clicks
  if (linkedinLink) {
    linkedinLink.addEventListener('click', function (e) {
      Logger.debug('linkedin_click', 'User clicked on author LinkedIn profile')
    })
  }

  // Reset button state when the page loads
  resetButtonState()
})
